import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    profileEmail: null,
    profileFirstName: null,
    profileLastName: null,
    profileUsername: null,
    profileId: null,
    profileInitials: null,
    profilePhoneNumber: null,
    profileAdminStatus: null,
    profileCart: null,
    profileCartLength: 0,
    profileCartRestaurantSummary: null,
    profileCartRestaurantId: null,
    profileCartRestaurantName: null,
    profileCartRestaurantLocation: null,
    orders: [],
    specificOrder: [],
  },
  mutations: {
    updateUser(state, payload) {
      state.user = payload;
    },
    setProfileInfo(state, doc) {
      state.profileId = doc.id;
      state.profileEmail = doc.data().email;
      state.profileFirstName = doc.data().firstName;
      state.profileLastName = doc.data().lastName;
      state.profileUsername = doc.data().username;
      state.profilePhoneNumber = doc.data().phoneNumber;
      state.profileAdminStatus = doc.data().admin;
      state.profileCart = doc.data().cart;
      state.profileCartLength =
        state.profileCart.length === 0 ? 0 : (state.profileCart.length - 1) / 3;
    },
    setProfileInitials(state) {
      state.profileInitials =
        state.profileFirstName.match(/(\b\S)?/g).join("") +
        state.profileLastName.match(/(\b\S)?/g).join("");
    },
    setProfileCart(state, doc) {
      state.profileCartRestaurantId = doc.id;
      state.profileCartRestaurantName = doc.data().name;
      state.profileCartRestaurantLocation = doc.data().location;
      state.profileCartRestaurantSummary = {
        id: doc.id,
        name: doc.data().name,
        location: doc.data().location,
      };
    },
    changeFirstName(state, payload) {
      state.profileFirstName = payload;
    },
    changeLastName(state, payload) {
      state.profileLastName = payload;
    },
    changeUsername(state, payload) {
      state.profileUsername = payload;
    },
    changePhoneNumber(state, payload) {
      state.profilePhoneNumber = payload;
    },
  },
  getters: {
    getSpecificOrder: (state) => state.specificOrder,
  },
  actions: {
    async getCurrentUser({ commit }) {
      const dataBase = await db
        .collection("users")
        .doc(firebase.auth().currentUser.uid);
      const dbResults = await dataBase.get();
      commit("setProfileInfo", dbResults);
      commit("setProfileInitials");
      if (this.state.profileCart.length !== 0) {
        //this.getRestaurantDetails();
        const dataBaseRestaurant = await db
          .collection("restaurants")
          .doc(this.state.profileCart[0]);
        const dbResultsRestaurant = await dataBaseRestaurant.get();
        commit("setProfileCart", dbResultsRestaurant);
      }
      console.log(dbResults);
    },
    async getRestaurantDetails({ commit, state }) {
      const dataBase = await db
        .collection("restaurants")
        .doc(state.profileCart[0]);
      const dbResults = await dataBase.get();
      commit("setProfileCart", dbResults);
    },
    async updateCart({ state }) {
      const dataBase = await db.collection("users").doc(state.profileId);
      await dataBase.update({
        cart: state.profileCart,
      });
    },

    async updateUserProfile({ commit, state }) {
      const database = await db.collection("users").doc(state.profileId);
      await database.update({
        firstName: state.profileFirstName,
        lastName: state.profileLastName,
        username: state.profileUsername,
        phoneNumber: state.profilePhoneNumber,
      });
      commit("setProfileInitials");
    },
    async getOrderDetails() {
      const OrdersCollection = firebase.firestore().collection("orders");

      if (this.state.orders.length == 0) {
        OrdersCollection.get().then((querysnapshot) => {
          //this.orders = querysnapshot; //this will lose track of data(dun know which is which)
          querysnapshot.forEach((doc) => {
            /* just to make sure data is fetched correctly*/
            // console.log(doc.id, "=>", doc.data());
            this.state.orders.push({ orderId: doc.id, ...doc.data() });
            // this.state.orders[doc.id]=doc.data();
          });
          console.log("AllORdersAreLoaded:", this.state.orders);
        });
      }
    },
    fetchSpecificOrder(state, payload) {
      const OrdersCollection = firebase.firestore().collection("orders");
      OrdersCollection.get().then((querysnapshot) => {
        //this.orders = querysnapshot; //this will lose track of data(dun know which is which)
        querysnapshot.forEach((doc) => {
          /* just to make sure data is fetched correctly*/
          // console.log(doc.id, "=>", doc.data());

          if (doc.id == payload.orderId) {
            this.state.specificOrder = doc.data();
          }
          // this.state.orders[doc.id]=doc.data();
        });
        console.log("SpecificLoaded:", this.state.specificOrder);
      });
    },
    getSpecificOrderById(id) {
      if (this.state.orders.length == 0) {
        this.actions.getOrderDetails();
        console.log("Actions Success:", this.state.orders);
        return this.state.orders.find((ord) => ord.orderId == id);
      }
    },
  },
  modules: {},
});
